import React, {useEffect } from 'react'; 
 import Header from '../Component/Header';
import { Link } from 'react-router-dom'
const AbsenceLeave = () => {
    useEffect(() => {
        document.title = 'Absence & Leave -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
     <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> The Almanac  </li>
                 <li>School Rules</li>
                 <li>Absence & Leave</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Absence & Leave </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                       <p>A minimum of 75% attendance is a pre requisite for the Final/Board Exam. The following rules must be followed in case leave becomes unavoidable:</p>
                    <ul className="list"> 
                    <li> In case a leave is planned, submit a leave application written by a parent in advance or an email can also be sent. </li>

                    <li> In case of absence due to illness or unforeseen circumstances submit a leave application within two working days of the student returning to school. </li>
                   
                    <li> A medical certificate is to be attached with application in case of illness. </li>
                   
                    <li> If a student has been suffering from an infectious disease, a dostor's certificate stating that the student is fit to attend school, after a quarantine period must be submitted. </li>
                   
                     <li> Repeated absence without leave or unexplained leave for more than 20 consecutive days will result in the student's name being struck off from the school rolls. </li>
                  </ul> 
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default AbsenceLeave